import { DEFAULT_LOCALE_FORMAT, LocaleFormat, LocaleLanguage } from 'models/locale-format';

// Super admins have no locale preference (they are not `users` documents), so dates
// and numbers always use the default format.
export const getCurrentLocaleFormat = (): LocaleFormat => DEFAULT_LOCALE_FORMAT;

// ISO 639-1 short code (e.g. `en`, `sv`) derived from the BCP47 language.
// Used by external integrations (Google geocoder, Unifaun tracking URLs) that
// expect 2-letter language codes rather than the full BCP47 form.
export const getShortLanguageCode = (language?: LocaleLanguage): string => {
    return (language ?? DEFAULT_LOCALE_FORMAT.language).split('_')[0];
};
